import React from "react";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

export type ButtonVariant = "danger" | "primary" | "secondary" | "success" | "warning" | "danger" | "info" | "link";

interface ISXButtonProps {
  id?: string;
  button?: boolean;
  disabled?: boolean;
  style?: React.CSSProperties;
  className?: string;
  size?: "sm" | "lg" | undefined;
  onClick?: () => void;
  icon?: IconProp;
  children?: React.ReactNode;
  title?: string;
  variant?: ButtonVariant;
}

export function SXButton(props: ISXButtonProps) {
  return (
    <>
      {props.button && props.disabled && (
        <Button
          id={props.id}
          style={props.style}
          className={props.className}
          size={props.size}
          disabled
          variant={props.variant ?? "primary"}
        >
          {props.icon && <FontAwesomeIcon icon={props.icon} style={{ marginRight: props.children ? 8 : 0 }} />}
          {props.children}
        </Button>
      )}
      {props.button && !props.disabled && (
        <Button
          id={props.id}
          style={props.style}
          className={props.className}
          size={props.size}
          onClick={props.onClick}
          variant={props.variant ?? "primary"}
        >
          {props.icon && <FontAwesomeIcon icon={props.icon} style={{ marginRight: props.children ? 8 : 0 }} />}
          {props.children}
        </Button>
      )}

      {!props.button && props.disabled && (
        <span style={Object.assign({ cursor: "pointer" }, props.style)}>
          {props.icon && <FontAwesomeIcon icon={props.icon} />}
          {props.children}
        </span>
      )}
      {!props.button && !props.disabled && (
        <span style={Object.assign({ cursor: "pointer" }, props.style)} onClick={props.onClick}>
          {props.icon && <FontAwesomeIcon icon={props.icon} />}
          {props.children}
        </span>
      )}
    </>
  );
}
